@if (actions['Activate']) {
  <LOSx-activate-center></LOSx-activate-center>
}
@if (actions['Assign Staff']) {
  <LOSx-center-assign-staff></LOSx-center-assign-staff>
}
@if (actions['Close']) {
  <LOSx-close-center></LOSx-close-center>
}
@if (actions['Attendance']) {
  <LOSx-center-attendance></LOSx-center-attendance>
}
@if (actions['Attach Meeting']) {
  <LOSx-attach-center-meeting></LOSx-attach-center-meeting>
}
@if (actions['Edit Meeting']) {
  <LOSx-edit-center-meeting></LOSx-edit-center-meeting>
}
@if (actions['Edit Meeting Schedule']) {
  <LOSx-edit-center-meeting-schedule></LOSx-edit-center-meeting-schedule>
}
@if (actions['Manage Groups']) {
  <LOSx-manage-groups></LOSx-manage-groups>
}
@if (actions['Staff Assignment History']) {
  <LOSx-staff-assignment-history></LOSx-staff-assignment-history>
}
